/**
 * Formate un montant en devise XOF
 */
export function formatCurrency(value) {
  if (value == null) return '0 FCFA'
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'XOF',
    maximumFractionDigits: 0
  }).format(value)
}

/**
 * Formate un nombre entier avec separateur de milliers
 */
export function formatInteger(value) {
  if (value == null) return '0'
  return new Intl.NumberFormat('fr-FR').format(Math.round(value))
}

/**
 * Formate un pourcentage d'evolution
 */
export function formatEvolution(value) {
  if (value == null || value === 0) return '0%'
  const sign = value > 0 ? '+' : ''
  return `${sign}${value.toFixed(1)}%`
}

/**
 * Formate un pourcentage
 */
export function formatPercent(value) {
  if (value == null) return '0%'
  return `${value.toFixed(1)}%`
}

/**
 * Formate une valeur selon le type specifie
 */
export function formatValue(value, format) {
  switch (format) {
    case 'currency':
      return formatCurrency(value)
    case 'integer':
      return formatInteger(value)
    case 'percent':
      return formatPercent(value)
    default:
      return String(value ?? 0)
  }
}
